import { render, staticRenderFns } from "./chineselogin.vue?vue&type=template&id=716f2d56&scoped=true&"
import script from "./chineselogin.vue?vue&type=script&lang=js&"
export * from "./chineselogin.vue?vue&type=script&lang=js&"
import style0 from "./chineselogin.vue?vue&type=style&index=0&id=716f2d56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f2d56",
  null
  
)

export default component.exports